export const API_URL = process.env.REACT_APP_API_URL
export const BASE_URL = process.env.REACT_APP_URL
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID
export const PAYSTACK_PUBLIC_KEY = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY










// export const BASE_URL = 'http://localhost:3000/'
// export const API_URL = 'http://192.168.0.238:3001/'
// export const API_URL = 'http://192.168.0.125:3001/'